/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */

var __assign = function() {
    __assign = Object.assign || function __assign(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};

function __values(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
}

function __read(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
}

function __spread() {
    for (var ar = [], i = 0; i < arguments.length; i++)
        ar = ar.concat(__read(arguments[i]));
    return ar;
}

var DIRECTIVE_PREFIX = 'l-';
var DIRECTIVE_SHORTHANDS;

(function (DIRECTIVE_SHORTHANDS) {
  DIRECTIVE_SHORTHANDS["@"] = "on";
  DIRECTIVE_SHORTHANDS[":"] = "bind";
})(DIRECTIVE_SHORTHANDS || (DIRECTIVE_SHORTHANDS = {}));

var rawDirectiveSplitRE = function rawDirectiveSplitRE() {
  return /:|\./gim;
};
var arrayIndexCaptureRE = function arrayIndexCaptureRE() {
  return /\[(\d+)\]/gim;
};
var eventDirectivePrefixRE = function eventDirectivePrefixRE() {
  return /on|@/gim;
};
var parenthesisWrapReplaceRE = function parenthesisWrapReplaceRE() {
  return /\(|\)/gim;
};
var hasDirectiveRE = function hasDirectiveRE() {
  return new RegExp("(" + DIRECTIVE_PREFIX + "|" + Object.keys(DIRECTIVE_SHORTHANDS).join('|') + ")\\w+", 'gim');
};
var expressionPropRE = function expressionPropRE(prop) {
  return new RegExp("\\b" + prop + "\\b", 'gim');
};

function _typeof(obj) {
  "@babel/helpers - typeof";

  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function (obj) {
      return typeof obj;
    };
  } else {
    _typeof = function (obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

var formatAcceptableWhitespace = function formatAcceptableWhitespace(expression) {
  return expression.replace(/\s+/gim, ' ').trim();
};
var bindDirective = function bindDirective(_a) {
  var el = _a.el,
      name = _a.name,
      data = _a.data,
      state = _a.state;

  switch (name.split(':')[1]) {
    case 'class':
      var hydratedClasses = data.compute(state);

      if (typeof hydratedClasses === 'string') {
        return el.setAttribute('class', formatAcceptableWhitespace(el.className + " " + hydratedClasses));
      } else if (hydratedClasses instanceof Array) {
        return el.setAttribute('class', formatAcceptableWhitespace(el.className + " " + hydratedClasses.join(' ')));
      } else {
        var classes = [];

        for (var prop in hydratedClasses) {
          if (hydratedClasses[prop]) classes.push(prop);
        }

        var removeDynamicClassesRE = new RegExp("\\b" + Object.keys(hydratedClasses).join('|') + "\\b", 'gim');
        var rawClasses = el.className.replace(removeDynamicClassesRE, '');

        if (classes.length > 0) {
          return el.setAttribute('class', formatAcceptableWhitespace(rawClasses + " " + classes.join(' ')));
        } else if (formatAcceptableWhitespace(el.className).length > 0) {
          return el.setAttribute('class', formatAcceptableWhitespace(rawClasses));
        } else {
          return el.removeAttribute('class');
        }
      }

    case 'style':
      var hydratedStyles = data.compute(state);
      el.removeAttribute('style');

      for (var prop in hydratedStyles) {
        el.style[prop] = hydratedStyles[prop];
      }

      break;

    default:
      var hydratedAttributes = data.compute(state);

      if (_typeof(hydratedAttributes) === 'object' && hydratedAttributes !== null) {
        for (var prop in hydratedAttributes) {
          if (hydratedAttributes[prop]) {
            el.setAttribute(prop, hydratedAttributes[prop]);
          } else {
            el.removeAttribute(prop);
          }
        }
      } else if (hydratedAttributes) {
        el.setAttribute(name.split(':')[1], hydratedAttributes);
      } else {
        el.removeAttribute(name.split(':')[1]);
      }

      break;
  }
};

var interpretProps = function interpretProps(expression, stateValues, positionInState) {
  var value = stateValues[positionInState];
  var arrayIndex = arrayIndexCaptureRE().exec(expression);

  if (arrayIndex && arrayIndex[1] && value instanceof Array && !isNaN(arrayIndex[1])) {
    return value[Number(arrayIndex[1])];
  } else if (expression.endsWith('()')) {
    return value();
  } else {
    return value;
  }
};
var computeExpression = function computeExpression(expression, el, returnable) {
  var formattedExpression = "with($state){" + ((returnable !== null && returnable !== void 0 ? returnable : true) ? "return " + expression : expression) + "}";
  return function (state) {
    try {
      var _a = __read([Object.keys(state), Object.values(state)], 2),
          propKeys = _a[0],
          propValues = _a[1];

      var strippedExpression = expression.replace(/(\[\d+\])|(\$state\.)|(\(\))|;*/gim, '');
      var positionInState = returnable ? propKeys.indexOf(strippedExpression) : -1;

      if (positionInState !== -1) {
        return interpretProps(expression, propValues, positionInState);
      } else {
        var emit = function emit(name, options) {
          var event = new CustomEvent(name, options);
          document.dispatchEvent(event);
        };

        return new Function('$state', '$el', '$emit', formattedExpression)(state, el, emit);
      }
    } catch (err) {
      console.warn("Lucia Error: \"" + err + "\"\n\nExpression: \"" + expression + "\"\nElement:", el);
    }
  };
};

var getCustomProp = function getCustomProp(el, prop) {
  return el[prop];
};
var setCustomProp = function setCustomProp(el, prop, value) {
  return el[prop] = value;
};

var removeDupesFromArray = function removeDupesFromArray(array) {
  return __spread(new Set(array));
};
var isListRenderScope = function isListRenderScope(el) {
  return el.hasAttribute(DIRECTIVE_PREFIX + "for");
};
var isUnderListRenderScope = function isUnderListRenderScope(el) {
  if (!el.parentElement) return false;
  return el.parentElement.hasAttribute(DIRECTIVE_PREFIX + "for");
};
var createASTNode = function createASTNode(el, state) {
  var _a = __read(collectAndInitDirectives(el, state), 2),
      directives = _a[0],
      deps = _a[1];

  var hasDirectives = Object.keys(directives).length > 0;
  var hasDepInDirectives = Object.values(directives).some(function (_a) {
    var value = _a.value;
    return Object.keys(state).some(function (prop) {
      return expressionPropRE(prop).test(value);
    });
  });
  if (!hasDirectives) return null;
  return {
    el: el,
    deps: deps,
    directives: directives,
    type: hasDepInDirectives ? 1 : 0
  };
};
var collectAndInitDirectives = function collectAndInitDirectives(el, state) {
  var e_1, _a;

  if (state === void 0) {
    state = {};
  }

  var directives = {};
  var nodeDeps = [];

  var _loop_1 = function _loop_1(name_1, value) {
    var depsInFunctions = [];
    var propsInState = Object.keys(state);
    var returnable = true;
    var deps = propsInState.filter(function (prop) {
      var hasDep = expressionPropRE(prop).test(String(value));

      if (typeof state[prop] === 'function' && hasDep) {
        var depsInFunction = propsInState.filter(function (p) {
          return expressionPropRE(p).test(String(state[prop]));
        });
        depsInFunctions.push.apply(depsInFunctions, __spread(depsInFunction));
      }

      return hasDep;
    });
    if (eventDirectivePrefixRE().test(name_1)) returnable = false;

    if (name_1.includes('for') && getCustomProp(el, '__l_for_template') === undefined) {
      setCustomProp(el, '__l_for_template', String(el.innerHTML).trim());
      returnable = false;
    }

    var uniqueCompiledDeps = removeDupesFromArray(__spread(deps, depsInFunctions));
    nodeDeps.push.apply(nodeDeps, __spread(uniqueCompiledDeps));
    var directiveData = {
      compute: computeExpression(value, el, returnable),
      deps: uniqueCompiledDeps,
      value: value
    };

    if (name_1.startsWith(DIRECTIVE_PREFIX)) {
      directives[name_1.slice(DIRECTIVE_PREFIX.length)] = directiveData;
    } else if (Object.keys(DIRECTIVE_SHORTHANDS).includes(name_1[0])) {
      directives[DIRECTIVE_SHORTHANDS[name_1[0]] + ":" + name_1.slice(1)] = directiveData;
    }
  };

  try {
    for (var _b = __values(el.attributes), _c = _b.next(); !_c.done; _c = _b.next()) {
      var _d = _c.value,
          name_1 = _d.name,
          value = _d.value;

      _loop_1(name_1, value);
    }
  } catch (e_1_1) {
    e_1 = {
      error: e_1_1
    };
  } finally {
    try {
      if (_c && !_c.done && (_a = _b["return"])) _a.call(_b);
    } finally {
      if (e_1) throw e_1.error;
    }
  }

  return [directives, removeDupesFromArray(nodeDeps)];
};
var extractNodeChildrenAsCollection = function extractNodeChildrenAsCollection(rootNode, isListGroup) {
  var e_2, _a;

  if (isListGroup === void 0) {
    isListGroup = false;
  }

  var collection = [];
  var isList = isListRenderScope(rootNode);
  var isUnderList = isUnderListRenderScope(rootNode);
  if (!isListGroup && (isList || isUnderList)) return collection;
  if (!isListGroup || !isList) collection.push(rootNode);

  if (!isList && !isUnderList || isListGroup) {
    try {
      for (var _b = __values(rootNode.childNodes), _c = _b.next(); !_c.done; _c = _b.next()) {
        var childNode = _c.value;

        if (childNode.nodeType === Node.ELEMENT_NODE) {
          if (!isListGroup && isListRenderScope(childNode)) {
            collection.push(childNode);
          } else {
            collection.push.apply(collection, __spread(extractNodeChildrenAsCollection(childNode, isListGroup)));
          }
        }
      }
    } catch (e_2_1) {
      e_2 = {
        error: e_2_1
      };
    } finally {
      try {
        if (_c && !_c.done && (_a = _b["return"])) _a.call(_b);
      } finally {
        if (e_2) throw e_2.error;
      }
    }
  }

  return collection;
};
var compile = function compile(el, state) {
  var e_3, _a;

  if (state === void 0) {
    state = {};
  }

  if (!el) throw new Error('Please provide a Element');
  var ast = [];
  var isListGroup = getCustomProp(el, '__l') !== undefined && isListRenderScope(el);
  var nodes = extractNodeChildrenAsCollection(el, isListGroup);

  try {
    for (var nodes_1 = __values(nodes), nodes_1_1 = nodes_1.next(); !nodes_1_1.done; nodes_1_1 = nodes_1.next()) {
      var node = nodes_1_1.value;
      if (node.hasAttribute(DIRECTIVE_PREFIX + "state")) continue;

      if (hasDirectiveRE().test(node.outerHTML)) {
        var newASTNode = createASTNode(node, state);
        if (newASTNode) ast.push(newASTNode);
      }
    }
  } catch (e_3_1) {
    e_3 = {
      error: e_3_1
    };
  } finally {
    try {
      if (nodes_1_1 && !nodes_1_1.done && (_a = nodes_1["return"])) _a.call(nodes_1);
    } finally {
      if (e_3) throw e_3.error;
    }
  }

  return ast;
};

var patch = function patch(ast, directives, state, changedProps) {
  var e_1, _a;

  if (state === void 0) {
    state = {};
  }

  if (changedProps === void 0) {
    changedProps = [];
  }

  var staticNodeCleanupQueue = [];

  var _loop_1 = function _loop_1(i) {
    var e_2, _a;

    var node = ast[i];
    var isStatic = node.type === 0;
    if (isStatic) staticNodeCleanupQueue.push(i);
    var nodeHasDep = changedProps.some(function (prop) {
      return node.deps.includes(prop);
    });
    if (!nodeHasDep && !isStatic) return "continue";

    var _loop_2 = function _loop_2(directiveName, directiveData) {
      var directiveHasDep = changedProps.some(function (prop) {
        return directiveData.deps.includes(prop);
      });

      if (directiveHasDep || isStatic) {
        var directiveProps = {
          el: node.el,
          name: directiveName,
          data: directiveData,
          node: node,
          state: state
        };
        renderDirective(directiveProps, directives);
      }
    };

    try {
      for (var _b = (e_2 = void 0, __values(Object.entries(node.directives))), _c = _b.next(); !_c.done; _c = _b.next()) {
        var _d = __read(_c.value, 2),
            directiveName = _d[0],
            directiveData = _d[1];

        _loop_2(directiveName, directiveData);
      }
    } catch (e_2_1) {
      e_2 = {
        error: e_2_1
      };
    } finally {
      try {
        if (_c && !_c.done && (_a = _b["return"])) _a.call(_b);
      } finally {
        if (e_2) throw e_2.error;
      }
    }
  };

  for (var i = 0; i < ast.length; i++) {
    _loop_1(i);
  }

  try {
    for (var staticNodeCleanupQueue_1 = __values(staticNodeCleanupQueue), staticNodeCleanupQueue_1_1 = staticNodeCleanupQueue_1.next(); !staticNodeCleanupQueue_1_1.done; staticNodeCleanupQueue_1_1 = staticNodeCleanupQueue_1.next()) {
      var i = staticNodeCleanupQueue_1_1.value;
      ast.splice(i, 1);
    }
  } catch (e_1_1) {
    e_1 = {
      error: e_1_1
    };
  } finally {
    try {
      if (staticNodeCleanupQueue_1_1 && !staticNodeCleanupQueue_1_1.done && (_a = staticNodeCleanupQueue_1["return"])) _a.call(staticNodeCleanupQueue_1);
    } finally {
      if (e_1) throw e_1.error;
    }
  }
};

var htmlDirective = function htmlDirective(_a) {
  var _b;

  var el = _a.el,
      data = _a.data,
      state = _a.state;
  el.innerHTML = (_b = data.compute(state)) !== null && _b !== void 0 ? _b : data.value;
  var ast = compile(el, state);
  patch(ast, directives, state, data.deps);
};

var ifDirective = function ifDirective(_a) {
  var _b, _c;

  var el = _a.el,
      data = _a.data,
      state = _a.state,
      node = _a.node;
  node = node;
  var hydratedConditional = !!data.compute(state);

  if (!getCustomProp(node.el, '__l_if_template')) {
    var template = document.createElement('template');
    setCustomProp(template, '__l_if_template', true);
    template.content.appendChild(el.cloneNode(true));
    el.replaceWith(template);
    node.el = template;
  }

  var hasInserted = getCustomProp(node.el, '__l_if_has_inserted');

  if (!hydratedConditional && hasInserted) {
    (_b = node.el.nextElementSibling) === null || _b === void 0 ? void 0 : _b.remove();
    setCustomProp(node.el, '__l_has_inserted', false);
  } else if (hydratedConditional && !hasInserted) {
    var clone = node.el.content.cloneNode(true);
    (_c = node.el.parentElement) === null || _c === void 0 ? void 0 : _c.insertBefore(clone, node.el.nextElementSibling);
    setCustomProp(node.el, '__l_has_inserted', true);
    var nextEl = node.el.nextElementSibling;
    nextEl.removeAttribute('l-if');
    var ast = compile(nextEl, state);
    patch(ast, directives, state, Object.keys(state));
  }
};

var inputCallback = function inputCallback(el, hydratedValue, data, state) {
  var isNumber = typeof hydratedValue === 'number' && !isNaN(el.value);
  var isBoolean = typeof hydratedValue === 'boolean' && (el.value === 'true' || el.value === 'false');
  var isNullish = (hydratedValue === null || hydratedValue === undefined) && (el.value === 'null' || el.value === 'undefined');
  var payload;

  if (isNumber) {
    payload = parseFloat(el.value);
  } else if (isBoolean) {
    payload = el.value === 'true';
  } else if (isNullish) {
    if (el.value === 'null') payload = null;else payload = undefined;
  } else {
    payload = String(el.value);
  }

  state[data.value] = payload;
  return payload;
};
var modelDirective = function modelDirective(_a) {
  var awaitingTypecastEl = _a.el,
      name = _a.name,
      data = _a.data,
      state = _a.state;
  var el = awaitingTypecastEl;
  var hydratedValue = state[data.value];

  if (el.value !== String(hydratedValue)) {
    el.value = String(hydratedValue);
  }

  if (!getCustomProp(el, '__l_model_registered')) {
    var _b = __read(name.split('.'), 2),
        prop = _b[1];

    var callback = function callback() {
      return inputCallback(el, hydratedValue, data, state);
    };

    el.addEventListener(prop === 'debounce' ? 'change' : 'input', callback);
    setCustomProp(el, '__l_model_registered', true);
  }
};

var onDirective = function onDirective(_a) {
  var el = _a.el,
      name = _a.name,
      data = _a.data,
      state = _a.state;
  var options = {};
  var globalScopeEventProps = ['away', 'global'];
  if (getCustomProp(el, '__l_on_registered')) return;

  var _b = __read(name.split('.'), 2),
      directiveAndEventName = _b[0],
      prop = _b[1];

  var eventName = directiveAndEventName.split(':')[1];
  var eventProp = prop || null;

  var handler = function handler($event) {
    if (eventProp === 'prevent') $event.preventDefault();
    if (eventProp === 'stop') $event.stopPropagation();

    if (eventProp === 'away') {
      if (el.contains($event.target)) return;
      if (el.offsetWidth < 1 && el.offsetHeight < 1) return;
    }

    data.compute(state);
  };

  options.once = eventProp === 'once';
  options.passive = eventProp === 'passive';
  (globalScopeEventProps.includes(String(eventProp)) ? document : el).addEventListener(eventName, handler, options);
  setCustomProp(el, '__l_on_registered', true);
};

var textDirective = function textDirective(_a) {
  var _b;

  var el = _a.el,
      data = _a.data,
      state = _a.state;
  el.textContent = (_b = data.compute(state)) !== null && _b !== void 0 ? _b : data.value;
};

var forDirective = function forDirective(_a) {
  var el = _a.el,
      data = _a.data,
      state = _a.state;

  var _b = __read(data.value.split(/in +/g), 2),
      expression = _b[0],
      target = _b[1];

  var _c = __read(expression.replace(parenthesisWrapReplaceRE(), '').split(','), 2),
      item = _c[0],
      index = _c[1];

  var currArray = state[target];
  var template = getCustomProp(el, '__l_for_template');
  if (el.innerHTML.trim() === template) el.innerHTML = '';
  var arrayDiff = currArray.length - el.children.length;
  if (currArray.length === 0) el.innerHTML = '';else if (arrayDiff !== 0) {
    for (var i = Math.abs(arrayDiff); i > 0; i--) {
      if (arrayDiff < 0) el.removeChild(el.lastChild);else {
        var tag = template.startsWith('<th') ? 'thead' : template.startsWith('<td') || template.startsWith('<tr') ? 'tbody' : 'div';
        var temp = document.createElement(tag);
        var content = template;

        if (item) {
          content = content.replace(expressionPropRE("this\\." + item.trim()), target + "[" + (currArray.length - i) + "]");
        }

        if (index) {
          content = content.replace(expressionPropRE("this\\." + index.trim()), String(currArray.length - i));
        }

        temp.innerHTML = content;
        el.appendChild(temp.firstElementChild);
      }
    }
  }
  setCustomProp(el, '__l', true);
  var ast = compile(el, state);
  patch(ast, directives, state, data.deps);
};

var directives = {
  BIND: bindDirective,
  HTML: htmlDirective,
  IF: ifDirective,
  MODEL: modelDirective,
  ON: onDirective,
  TEXT: textDirective,
  FOR: forDirective
};
var renderDirective = function renderDirective(props, directives) {
  var name = props.name.split(rawDirectiveSplitRE())[0];
  directives[name.toUpperCase()](props);
};

var arrayEquals = function arrayEquals(firstArray, secondArray) {
  return firstArray instanceof Array && secondArray instanceof Array && firstArray.length === secondArray.length && firstArray.every(function (value, i) {
    return value === secondArray[i];
  });
};
var reactive = function reactive(state, callback) {
  var handler = {
    get: function get(target, key) {
      if (_typeof(target[key]) === 'object' && target[key] !== null) {
        return new Proxy(target[key], handler);
      } else {
        return target[key];
      }
    },
    set: function set(target, key, value) {
      if (typeof state[key] === 'function') return false;
      var hasArrayMutationKey = !isNaN(Number(key)) || key === 'length';
      var props = [];

      if (target instanceof Array && hasArrayMutationKey) {
        props = Object.keys(state).filter(function (prop) {
          return arrayEquals(state[prop], target);
        });
      } else {
        if (Object.keys(state).some(function (prop) {
          return target[prop] === undefined;
        })) {
          props = Object.keys(state).filter(function (prop) {
            return _typeof(state[prop]) === 'object';
          });
        } else {
          props = [key];
        }
      }

      target[key] = value;
      callback(props);
      return true;
    }
  };
  return Proxy.revocable(Object.seal(state), handler);
};

var Component = function () {
  function Component(state) {
    if (state === void 0) {
      state = {};
    }

    this.state = state;
    this.directives = {};
  }

  Component.prototype.mount = function (el) {
    var rootEl = typeof el === 'string' ? document.querySelector(el) : el;
    this.ast = compile(rootEl, this.state);
    this.state = reactive(this.state, this.render.bind(this)).proxy;
    this.directives = __assign(__assign({}, this.directives), directives);
    this.render();
    setCustomProp(rootEl, '__l', this);
    return this.state;
  };

  Component.prototype.directive = function (name, callback) {
    this.directives[name.toUpperCase()] = callback;
  };

  Component.prototype.render = function (props) {
    if (props === void 0) {
      props = Object.keys(this.state);
    }

    patch(this.ast, directives, this.state, props);
  };

  return Component;
}();
var component = function component(state) {
  return new Component(state);
};

var luciaLoadEvent = new CustomEvent('lucia:load');
var init = function init(element) {
  if (element === void 0) {
    element = document;
  }

  var stateDirective = DIRECTIVE_PREFIX + "state";

  var elements = __spread(element.querySelectorAll("[" + stateDirective + "]"));

  elements.filter(function (el) {
    return getCustomProp(el, '__l') === undefined;
  }).map(function (el) {
    var expression = el.getAttribute(stateDirective);

    try {
      var state = new Function("return " + (expression || {}));
      component(state()).mount(el);
    } catch (err) {
      console.warn("Lucia Error: \"" + err + "\"\n\nExpression: \"" + expression + "\"\nElement:", el);
    }
  });
  document.dispatchEvent(luciaLoadEvent);
};

export { compile, component, directives, init, luciaLoadEvent, patch, reactive };
